import { Box, Container, Typography, Link } from '@mui/material';

export default function Terms() {
  return (
    <Box sx={{ pb: { xs: 6, md: 8 } }}>
      <Box sx={{ bgcolor: 'primary.light', py: { xs: 4, md: 6 } }}>
        <Typography variant="h4" align="center" fontWeight={700}>
          Terms & Conditions
        </Typography>
      </Box>

      <Container maxWidth="md" sx={{ mt: { xs: 4, md: 6 } }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
          Acceptance of Terms
        </Typography>
        <Typography paragraph>
          By using BondPay Rental Services provided you agree to these Terms and Conditions. If you do not agree to these terms, you should not use our services.
        </Typography>

        <Typography variant="h6" fontWeight={700} gutterBottom>
          Applicant's Consent
        </Typography>
        <Typography paragraph>
          By applying for our services, applicants consent to undergo this third party credit check and acknowledge that the outcome of this assessment is solely determined by the third-party agency.
        </Typography>

        <Typography variant="h6" fontWeight={700} gutterBottom>
          Services Description
        </Typography>
        <Typography paragraph>
          BondPay provides interest free rental bond loans through a third-party service.
        </Typography>

        <Typography variant="h6" fontWeight={700} gutterBottom>
          Credit Check and Approval
        </Typography>
        <Typography paragraph>a. Mandatory Credit Assessment:</Typography>
        <Typography paragraph>
          Third-Party Involvement: All clients are required to undergo a credit assessment conducted by an independent third-party service. This process is a mandatory prerequisite for accessing our services.
        </Typography>
        <Typography paragraph>
          Applicant's Consent: By applying, clients consent to this credit check and acknowledge that the results are determined independently by the third-party agency.
        </Typography>
        <Typography paragraph>
          Compliance with Privacy Laws: The credit assessment process complies with the Australian Privacy Principles (APPs) and other relevant legislation.
        </Typography>
        <Typography paragraph>
          c. Modification of Eligibility Criteria: Bond Pay Rental Services PTY LTD may, at its discretion and in compliance with applicable laws, modify the eligibility criteria for its services. Any such changes will be communicated promptly through official channels.
        </Typography>
        <Typography paragraph>
          b. Approval of Services:
        </Typography>
        <Typography paragraph>
          Dependence on Credit Outcome: The approval of any loans or services offered by BondPay is directly contingent on the results of the credit assessment conducted by the third-party provider.
        </Typography>
        <Typography paragraph>
          Notification of Results: Clients will be promptly notified of the outcome of the credit check and the consequent approval or denial of services.
        </Typography>
        <Typography paragraph>
          Dispute Resolution: In cases of adverse findings, clients will be provided with the necessary information to contact the third-party agency for any disputes or clarifications.
        </Typography>

        <Typography variant="h6" fontWeight={700} gutterBottom>
          Company's Liabilities and Limitations
        </Typography>
        <Typography paragraph>
          Service Interruptions: Bond Pay Rental Services PTY LTD is not liable for any service interruptions or unavailability due to external factors beyond its control.
        </Typography>
        <Typography paragraph>
          Data Accuracy: Bond Pay Rental Services PTY LTD is not responsible for errors or omissions in information provided by third parties.
        </Typography>
        <Typography paragraph>
          Third-party Actions: Bond Pay Rental Services PTY LTD is not liable for actions or omissions of third-party partners.
        </Typography>
        <Typography paragraph>
          Dispute Resolution
          <br />
          Internal dispute release resolution process for any issues or complaints. Please submit a complaint via email to{' '}
          <Link href="mailto:Hello@bondpay.au" color="primary.main">
            Hello@bondpay.au
          </Link>
          , and this will be handled using our internal policy for handling complaints which you can obtain a copy of by emailing us.
        </Typography>

        <Typography variant="h6" fontWeight={700} gutterBottom>
          8. Legal Compliance
        </Typography>
        <Typography paragraph>
          These terms are subject to change in accordance with Australian law.
        </Typography>
      </Container>
    </Box>
  );
}